import { render, staticRenderFns } from "./SfCircleIcon.vue?vue&type=template&id=aa8120b4&functional=true&"
import script from "./SfCircleIcon.vue?vue&type=script&lang=js&"
export * from "./SfCircleIcon.vue?vue&type=script&lang=js&"
import style0 from "./SfCircleIcon.vue?vue&type=style&index=0&id=aa8120b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports